// Every App Store link on the site (#19): the Learn custom product page, the
// team's provider token and a campaign name, so App Store Connect credits
// downloads to the page and to the button that sent them
// (App Analytics > Acquisition > Campaigns). Same format Apple's campaign
// link generator produces.
const APP_ID = '6742127631';
const PROVIDER_TOKEN = '853426';
const LEARN_PAGE = 'c8ff4fb6-1b7b-4967-bbf6-8ad0f3edc710';

export function appStoreUrl(campaign: string, ppid: string = LEARN_PAGE): string {
  const q = new URLSearchParams({ ppid, pt: PROVIDER_TOKEN, ct: campaign, mt: '8' });
  return `https://apps.apple.com/app/apple-store/id${APP_ID}?${q.toString()}`;
}
